import {
    type EnvironmentProviders,
    inject,
    makeEnvironmentProviders,
    provideEnvironmentInitializer,
} from "@angular/core";
import { PendoAgent } from "./pendo-agent";
import { PendoSessionService } from "./pendo-session.service";
import { type PendoConfig, PENDO_CONFIG } from "./pendo.config";
import { PendoProfileService } from "./profile/pendo-profile.service";
import { IdentityProfileSource } from "./profile/sources/identity/identity.pendo-profile-source";
import { LocalStorageProfileSource } from "./profile/sources/local-storage/local-storage.pendo-profile-source";
import { PendoIdsLocalStorageCacheService } from "./profile/sources/local-storage/pendo-ids-local-storage-cache.service";
import { CurrentServerProfileSource } from "./profile/sources/server/current-server.pendo-profile-source";
import { EitherServerProfileSource } from "./profile/sources/server/either-server.pendo-profile-source";
import { LegacyServerProfileSource } from "./profile/sources/server/legacy-server.pendo-profile-source";

/**
 * Turns on Pendo product analytics for the app, identifying each signed-in
 * session from bootstrap on. Requires `provideAuth()`, and
 * `withFirm360Interceptors()` for its requests to survive an outage.
 */
export function providePendo(config: PendoConfig): EnvironmentProviders {
    return makeEnvironmentProviders([
        { provide: PENDO_CONFIG, useValue: config },
        PendoAgent,
        PendoIdsLocalStorageCacheService,
        CurrentServerProfileSource,
        LegacyServerProfileSource,
        EitherServerProfileSource,
        IdentityProfileSource,
        LocalStorageProfileSource,
        PendoProfileService,
        PendoSessionService,
        provideEnvironmentInitializer(() => {
            inject(PendoSessionService);
        }),
    ]);
}
